import React, { useState } from 'react';
import { LayersIcon } from 'lucide-react';
interface LayerOption {
  id: string;
  label: string;
  checked: boolean;
}
interface LayerControlProps {
  layers: LayerOption[];
  onLayerChange: (layerId: string, checked: boolean) => void;
  className?: string;
}
export const LayerControl = ({
  layers,
  onLayerChange,
  className = ''
}: LayerControlProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);
  return <div className={`relative ${className}`} data-id="element-226">
      <button onClick={toggleOpen} className="bg-white p-2 rounded-lg shadow-md flex items-center justify-center" title="Toggle Map Layers" data-id="element-227">
        <LayersIcon className="w-5 h-5 text-gray-700" data-id="element-228" />
      </button>
      {isOpen && <div className="absolute top-full right-0 mt-2 bg-white rounded-lg shadow-lg p-3 z-[1000] w-64" data-id="element-229">
          <h3 className="font-bold text-sm mb-2 pb-2 border-b border-gray-200" data-id="element-230">
            Map Layers
          </h3>
          <div className="space-y-2" data-id="element-231">
            {layers.map(layer => <div key={layer.id} className="flex items-center" data-id="element-232">
                <input type="checkbox" id={`layer-${layer.id}`} checked={layer.checked} onChange={e => onLayerChange(layer.id, e.target.checked)} className="mr-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-233" />
                <label htmlFor={`layer-${layer.id}`} className="text-sm text-gray-700 font-medium cursor-pointer" data-id="element-234">
                  {layer.label}
                </label>
              </div>)}
          </div>
        </div>}
    </div>;
};